export enum CategoryNameId {
  ID = 'id',
  NAME_EN = 'nameEn',
  NAME_AR = 'nameAr',
  DESCRIPTION_EN = 'descriptionEn',
  DESCRIPTION_AR = 'descriptionAr',
  CREATED_AT = 'createdAt',
}
